import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createUserActionsSlice, createUserDataSlice } from './slices'
import type { UserStore } from './types'

export const useUserStore = create<UserStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createUserDataSlice(...args),
        ...createUserActionsSlice(...args),
      }))
    ),
    {
      name: 'UserStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
